import { CheckCircle, XCircle } from 'lucide-react';

// A single toast message — success (green) or error (red).
// Slides in from the top, auto-dismisses via the ToastContext timer.
function Toast({ type = 'success', message }) {
  const isSuccess = type === 'success';

  return (
    <div
      style={{
        ...styles.toast,
        backgroundColor: isSuccess ? '#065f46' : '#991b1b',
      }}
    >
      {isSuccess ? (
        <CheckCircle size={18} color="white" style={{ flexShrink: 0 }} />
      ) : (
        <XCircle size={18} color="white" style={{ flexShrink: 0 }} />
      )}
      <span style={styles.message}>{message}</span>
    </div>
  );
}

const styles = {
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 16px',
    borderRadius: 10,
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    maxWidth: 340,
    width: '90%',
  },
  message: {
    color: 'white',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.4,
  },
};

export default Toast;